import { getMessaging, getToken } from "@firebase/messaging";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import loginIMG from "../assets/images/login.svg";
import logoIMG from "../assets/images/logo.png";
import useStore from "../hooks/useStore";
import { useCloud } from "../hooks/useCloud";
// import io from 'socket.io-client'; // Import socket.io-client

// const socket = io('http://localhost:3000'); // Replace with your server URL

const LoginNew = () => {
  const { login } = useCloud();
  const { getCloudSync } = useStore();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [isSignUp, setIsSignUp] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Listen for the 'adminLogin' event from the server
    // socket.on('adminLogin', (data) => {
    //   alert(Admin logged in: ${data.name});
    //   console.log('Admin login event received:', data);
    // });
    // Clean up the socket connection when the component unmounts
    // return () => {
    //   socket.off('adminLogin');
    // };
  }, []);

  const handleLogin = async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await login({ email: username, password: password });

      if (response.status === "success") {
        const { accessToken, refreshToken } = response.data;
        if (accessToken) {
          localStorage.setItem("authToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("email", username);
          navigate("/table-overview");
        } else {
          setError("Something went wrong");
        }
      } else {
        setError(response.errorMessage.message);
      }
    } catch (error) {
      setError("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignUp = () => {
    setIsLoading(true);
    setError("");

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address.");
      setIsLoading(false);
    } else if (password.length < 6) {
      setError("Password must be at least 6 characters long.");
      setIsLoading(false);
    } else {
      setError("");
      alert("Sign up successful! Please log in.");
      setIsSignUp(false);
      setUsername("");
      setPassword("");
      setEmail("");
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex relative">
      {/* Logo - Absolute positioned to top left corner (Desktop only) */}
      <div className="absolute top-8 left-8 z-50 flex items-center gap-3 hidden lg:flex">
        <div className="bg-white rounded-xl p-2 shadow-lg">
          <img
            src={logoIMG}
            alt="QRapid Logo"
            className="w-8 h-8 object-contain"
          />
        </div>
        <h1 className="text-2xl font-bold text-white">QRapid</h1>
      </div>

      {/* Left Panel with Gradient Background */}
      <div className="hidden lg:flex w-[40%] items-center justify-center bg-gradient-to-br from-green-500 to-green-700 relative overflow-hidden pr-5">
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-green-600/20 to-green-800/20"></div>

        {/* Content */}
        <div className="relative z-10 text-left text-white px-8">
          {/* Main Tagline */}
          <h2 className="text-4xl font-normal mb-6 leading-tight">
            India's First Restaurant Growth Management Platform.
          </h2>

          {/* Sub Tagline */}
          <p className="text-xl text-green-100 leading-relaxed">
            Log in to manage your menu, orders, and growth <br /> all in one
            place
          </p>
        </div>
      </div>

      {/* Login Form Section */}
      <div className="flex-1 flex items-center justify-center p-4 lg:w-[60%]">
        <div className="w-full max-w-md">
          {/* Mobile Logo - Above Welcome Header */}
          <div className="text-center lg:hidden">
            <div className="inline-flex items-center justify-center gap-4 bg-white px-8 py-4 rounded-xl">
              <img
                src={logoIMG}
                alt="QRapid Logo"
                className="w-12 h-12 object-contain"
              />
              <h1 className="text-3xl font-bold bg-gradient-to-r from-green-500 to-green-700 bg-clip-text text-transparent">
                QRapid
              </h1>
            </div>
          </div>

          {/* Login Card */}
          <div className="bg-white rounded-2xl p-8">
            <div className="text-center mb-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Welcome Back
              </h2>
            </div>

            {error && (
              <div className="mb-6">
                <p className="text-red-600 text-sm text-center">{error}</p>
              </div>
            )}

            {isSignUp && (
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Email Address
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="Enter your email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-green-500 transition-colors"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            )}

            <div className="space-y-4">
              <div>
                <label
                  htmlFor="username"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Email
                </label>
                <input
                  id="username"
                  type="email"
                  placeholder="user@company.com"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-green-500 transition-colors"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  placeholder="Enter password"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-green-500 transition-colors"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            <button
              onClick={handleLogin}
              disabled={isLoading}
              className="w-full mt-6  bg-gradient-to-r from-green-600 to-green-700 text-white py-3 px-4 rounded-lg font-medium hover:from-green-700 hover:to-green-800 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all duration-200 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {isLoading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Signing In...
                </>
              ) : (
                "Log In"
              )}
            </button>
          </div>

          {/* Footer */}
          <div className="text-center mt-8">
            <p className="text-xs text-gray-500">
              © 2024 QRapid. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginNew;
